import { mdiLogoutVariant } from "@mdi/js";
import { useDispatch } from "app/store";
import { MaterialIcon } from "components/MaterialIcon";
import React from "react";
import styles from "./PrivateMobileHeader.module.scss";
import { Button } from "antd";
import useAuth from "features/auth/useAuth";
import { useTranslation } from "react-i18next";
import clsx from "clsx";
import Claims from "features/auth/claims";
import Logo from "../components/Logo";
import { Link } from "react-router-dom";

interface PrivateMobileHeaderProps {
  userName?: string | null;
}

const PrivateMobileHeader: React.FC<PrivateMobileHeaderProps> = ({
  userName,
}) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { hasClaim } = useAuth();

  return (
    <div className={styles.wrapper}>
      <Link to="/">
        <Logo light />
      </Link>

      {hasClaim([Claims.View.Desktop]) && (
        <Button
          onClick={() => {
            dispatch.common.setDeviceLayoutType("default");
            localStorage.setItem("fortana-view", "desktop");
          }}
          className={styles.viewSwitch}
          type="primary"
        >
          {t("common.view.desktop")}
        </Button>
      )}
      <div
        className={clsx({ [styles.names]: !hasClaim([Claims.View.Desktop]) })}
      >
        <span className={styles.userName}>{userName}</span>
      </div>
      <div
        className={styles.logoutWrapper}
        onClick={() => dispatch.auth.logout()}
      >
        <MaterialIcon path={mdiLogoutVariant} />
      </div>
    </div>
  );
};

export default PrivateMobileHeader;
